import React, { useState, useEffect, useContext } from 'react';
import { MsalContext } from '../../Contexts/MsalContext';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SelectModal } from '../SelectModal';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import FeedbackTableFiltersViewModel from '../../Feedback/ViewModels/FeedbackTableFiltersViewModel';
import { AgentNameViewModel } from '../ReworkedFilters/OperationsFilters/ViewModels/OperationsFiltersViewModel';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IAgentNameChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean;
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];

    filters: FeedbackTableFiltersViewModel;
    startDate: Date;
    endDate: Date;
    dateFlag: boolean;
    dateRangeFlag: boolean;
}

export default function AgentNameChip(props: IAgentNameChipProps) {
    const { msalFetch } = useContext(MsalContext);
    const [options, setOptions] = useState<any>([]);
    const [showInactiveAgentNames, setShowInactiveAgentNames] = useState(false);

    useEffect(() => {
        getAgents();
    }, [props.startDate, props.endDate, showInactiveAgentNames, props.client]);

    const getAgents = () => {
        msalFetch(`api/Search/GetAgentDropdown?client=` + encodeURIComponent(props.client) + "&showInactiveAgentNames=" + showInactiveAgentNames)
            .then(response => response.json())
            .then((data: any) => {
                setOptions(data.value.map((s: AgentNameViewModel) => s.name));
            });
    }

    const handleSelect = (name: any, value: any) => props.onSelect(name, value);

    const handleDelete = () => {
        if (props.removeFilter !== null && props.removeFilter !== undefined) {
            props.removeFilter(props.filterFlag, props.filterNames);
        }
    }

    const activeAgentFlagHandler = (checkboxValue: boolean) => {
        setShowInactiveAgentNames(checkboxValue);
    }

    return (
        <React.Fragment>
            {
                props.show &&
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{props.title}</Typography>
                        </Grid>
                        <SelectModal
                            title={props.title}
                            filterName={props.filterName}
                            mutliSelect={true}
                            currentSelection={props.currentSelection}
                            onSelect={handleSelect}
                            options={options}
                            searchable={true}
                            isAgentName={true}
                            activeAgentFlagHandler={activeAgentFlagHandler}
                        />
                        <Grid>
                            {props.removeFilter !== null && props.removeFilter !== undefined &&
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}>
                                    <CancelIcon />
                                </IconButton>
                            }
                        </Grid>
                    </Grid>
                </Grid >
            }
        </React.Fragment>

    );
}